// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O_wX","content":"styles_content__3VtK1"};